import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/biscuits/milk biscuit.png"; // renamed (no space)
import BiscuitImg from "../../../assets/products/biscuits/Milk-Biscuit.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 50,
  },
  {
    grams: 55,
  },
  {
    grams: 60,
  },
];

export default function MilkProduct() {
  return (
    <>
      <Helmet>
        <title>Milk Biscuits – BearBitz | Premium Biscuits & Cookies</title>
        <meta
          name="description"
          content="Explore BearBitz Milk Biscuits—crispy, mildly sweet, and perfect for tea-time. View pack sizes, cartons, and specs for global food manufacturing."
        />
        <meta name="keywords" content="Milk Biscuits, BearBitz Milk Biscuits" />
        <link
          rel="canonical"
          href="https://www.bearbitz.in/products/milk-biscuits"
        />
        <meta property="og:title" content="Milk Biscuits – BearBitz" />
        <meta
          property="og:description"
          content="Crispy, mildly sweet milk biscuits. Global-ready specs and packaging."
        />
      </Helmet>

      <ProductTemplate
        productTitle="MILK BISCUITS"
        productImage={BisImg}
        description="Power-Packed Bites of Energy. Crispy, mildly sweet, and full of goodness perfect for all ages, anytime. Trusted in tea breaks and snack times across the globe."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#0076D2"
        sectionBgColor="#B5DFFF"
        productBgcolor="#0076D2"
        tableheadBgcolor="#0076D2"
        tableBgcolor="#e2f3ff"
        footerBgcolor="#0076D2"
      />
    </>
  );
}
